// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colorPreview {
  height: 24px;
  border-radius: 4px;
  margin: 0px 4px;
}

.groupBorder {
  border: 1px solid lightgray;
  border-radius: 4px;
  margin-bottom: 4px;
  padding: 2px;
}

.colMargin {
    width: calc(100% - 40px);
}

.seriesDIV {
    margin-left: 4px;
    margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/reportobjectmenus/chart/series.menu.control.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".colorPreview {\n  height: 24px;\n  border-radius: 4px;\n  margin: 0px 4px;\n}\n\n.groupBorder {\n  border: 1px solid lightgray;\n  border-radius: 4px;\n  margin-bottom: 4px;\n  padding: 2px;\n}\n\n.colMargin {\n    width: calc(100% - 40px);\n}\n\n.seriesDIV {\n    margin-left: 4px;\n    margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
